(function(w, $){
	"use strict";
	
	var _brain = function(){
		this.init();
		return this;	
	};
	
	_brain.prototype = {
		required: {},
		init: function(){
			this.plugins = {};
		},
		log: function(m){
			console.log('BRAIN: ' + m);	
		},
		register: function(name, plugin){
			var _self = this;
			
			_self.plugins[name] = plugin;
			
			$.extend(plugin.prototype, {
				options: {}
			});
			
			$.fn[ 'br' + name.charAt(0).toUpperCase() + name.slice(1) ] = function(){
				var arg = $.merge([name, this], arguments);
				return _self.pluginCallback.apply(_self, arg);
			};
		},
		pluginCallback: function(name, elem, arg){
			var _self = this,
				args = arguments;
			
			if(arg === 'option' && args.length === 4){
				var instance = elem.first().data('bb' + name);
				
				if(instance){
					return instance.options[args[3]];
				}
				
				return false;
			}
			
			elem.each(function(){
				var $elem = $(this),
					instance = $elem.data('bb' + name);
				
				
				if(instance){
					if(instance[arg]){
						args = Array.prototype.slice.call( args, 3 );
						instance[arg].apply(instance, args);
					} else if (args.length === 5 && arg === 'option'){
						instance.options[args[3]] = args[4];
						if(instance.optionChanged){
							instance.optionChanged(args[3], args[4]);
						}
					}
					
					return $elem;
				} else if (typeof arg === 'object' || !arg){
					if(instance){
						return $elem;
					}
					
					instance = _self.newInstance(name, this, arg);
					
					$elem.data('bb' + name, instance);
					
					return $elem;
				} else {
					_self.log( 'The "' + arg + '" method doesn\'t exist for the "' + name + '" plugin' );
					return false;
				}
			});
			
			return elem;
		},
		newInstance: function(name, elem, arg){
			var _self = this,
				instance = new this.plugins[name]();
			
			instance.$elem = $(elem);
			$.extend(instance.options, 
					 instance.$elem.data('brain-' + name.toLowerCase()) || {},
					 arg
			);
			
			if(instance.requires){
				
				if(instance.preInit){
					instance.preInit.apply(instance, [arg]);
				}
				
				$.each(instance.requires, function(i){
					var fn = 'brain_' + i;
					
					_self.required[i] = _self.required[i] || {};
					_self.required[i].plugins = _self.required[i].plugins || [];
					
					_self.required[i].plugins.push(instance);
					
					if(!w[fn] && !_self.required[i].loaded){
						w[fn] = function(){
							_self.required[i].loaded = true;
							$.each(_self.required[i].plugins, function(){
								this.init.apply(this, [arg]);
							});
							_self.required[i].plugins = [];
						};
						var url = this + (this.indexOf('?') > -1 ? '&' : '?') + 'callback=' + fn;
						$.getScript(url);
					}
					
					
				});
				
			} else {
				if(instance.init){
					instance.init.apply(instance, [arg]);
				}
			}
			
			return instance;
		}
	};
	
	w.brain = new _brain();
	
	
	
})(window, jQuery);